import { AccountPage } from '@/pages/account';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/account')({
	component: AccountPage,
	validateSearch: (search) => {
		if (search?.to) {
			return { to: search.to as string };
		}
		return {};
	},
});
